import React, { useMemo, useState } from "react";
import { Box, Divider } from "@mui/material";
import { LargeButton, Ptag } from "components/core";
import subtract from "assets/svgs/addDel/subtract.svg";
import addition from "assets/svgs/addDel/add.svg";
import rupee from "assets/svgs/addDel/rupee.svg";
import { formatToRs } from "utlis/utils";
import useUser from "hooks/useUser";
import DownloadIcon from "assets/svgs/downloadNew.svg";
import styled from "styled-components";

const AddDeleteRow = ({ type, amount, premiumCalcDet }) => {
  const getIcon = (type) => {
    switch (type) {
      case "subtract":
        return addition;
      case "addition":
        return subtract;
      case "rupee":
        return rupee;
    }
  };

  const totalAmountTextHandler = () => {
    const premValue = premiumCalcDet?.total_added_premium || 0;
    const refValue = premiumCalcDet?.total_refund_premium || 0;
    if (premValue > refValue) {
      return "Total Estimated Premium";
    } else if (refValue > premValue) {
      return "Amount to be Credited";
    } else {
      return "Total Amount";
    }
  };

  const textHandler = (type) => {
    if (type === "subtract") {
      return "Refund from Deletions";
    } else if (type === "rupee") {
      // return "Total Amount";
      return totalAmountTextHandler();
    } else {
      return "Insurance Premium";
    }
  };

  const amountHandler = (amount, type) => {
    if (amount && type === "rupee") {
      return amount;
    } else if (amount && type !== "rupee") {
      return formatToRs(amount);
    } else {
      return "-";
    }
  };

  return (
    <section
      style={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "14px",
        }}
      >
        <Box sx={{ position: "relative", top: "-3px" }}>
          <img src={getIcon(type)} alt="" />
        </Box>
        <div>
          <div>
            <Ptag fontSize="14px" color="#4a4a4a">
              {textHandler(type, amount)}
            </Ptag>
          </div>
          <div>
            <Ptag
              fontSize="12px"
              color="#4A4A4A"
              fontWeight="400"
              marginTop="5px"
            >
              (incl. 18% GST)
            </Ptag>
          </div>
        </div>
      </div>
      <Ptag fontSize="16px" fontWeight="600" color="#4a4a4a">
        {/* {amount ? formatToRs(amount) : "-"} */}
        {amountHandler(amount, type)}
      </Ptag>
    </section>
  );
};

function PremiumCalc({ premiumCalcDet, showPremiumSubmitBtn }) {
  const { getRole } = useUser();
  const role = getRole();

  const totalAmount = useMemo(() => {
    const premium = premiumCalcDet?.total_added_premium || 0;
    const refund = premiumCalcDet?.total_refund_premium || 0;
    // return premium - refund;
    return Math.abs(refund - premium).toFixed(2);
  }, [premiumCalcDet]);

  const showDisplayBtn = () => {
    return (
      <>
        {role !== "admin" && showPremiumSubmitBtn && (
          <LargeButton
            type="submit"
            style={{
              marginTop: "68px",
            }}
            label="Submit"
          />
        )}
      </>
    );
  };

  return (
    <div>
      {premiumCalcDet && (
        <>
          <Divider
            sx={{
              borderColor: "black",
            }}
          />
          <header
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Ptag
              color="#4A4A4A"
              fontSize="18px"
              marginBottom="24px"
              fontWeight="600"
              marginTop="18px"
            >
              Estimated Premium
            </Ptag>
            <DownloadButton
              onClick={() => {
                window.open(premiumCalcDet?.premium_excel_file, "_blank");
              }}
            >
              <img
                style={{ marginRight: "3px", height: "16px", width: "16px" }}
                src={DownloadIcon}
              />
              <Ptag
                textAlign="center"
                fontSize="14px"
                fontWeight="600"
                color="white"
              >
                Estimated Premium
              </Ptag>
            </DownloadButton>
          </header>
          <div
            style={{
              background: "white",
              borderRadius: "10px",
              padding: "36px",
            }}
          >
            <section
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "14px",
              }}
            >
              <AddDeleteRow
                type="addition"
                amount={premiumCalcDet?.total_added_premium || 0}
              />
              <AddDeleteRow
                type="subtract"
                amount={premiumCalcDet?.total_refund_premium || 0}
              />
            </section>
            <Divider
              sx={{
                borderColor: "black",
                margin: "24px 0px",
              }}
            />
            <AddDeleteRow
              type="rupee"
              amount={totalAmount}
              premiumCalcDet={premiumCalcDet}
            />
          </div>
          <footer
            style={{
              borderRadius: "10px",
              background: "rgba(253, 189, 12, 0.46)",
              padding: "26px 32px",
              marginTop: "46px",
            }}
          >
            <Ptag
              color="#4a4a4a"
              fontWeight="600"
              marginBottom="6px"
              fontSize="14px"
            >
              Please Note:
            </Ptag>
            {/* <Ptag color="#4a4a4a" fontWeight="400">
          Please ensure your CD Balance is adequate. That will ensure seamless
          endorsements and policy generation. We recommend you keep an
          additional 10% amount in the CD account to avoid last-minute hassles
          in additions/deletions.
        </Ptag> */}
            <Box
              sx={{
                padding: "10px 10px 0px 15px",
                fontFamily: "Inter",
                fontSize: "12px",
                color: "#4a4a4a",
                lineHeight: "22px",
              }}
            >
              <ol>
                <li>
                  The date of enrollment should be within the policy period.
                </li>
                <li>
                  Midterm dependent additions to the policy are allowed only for
                  a newly married spouse and newborn children.
                </li>
                <li>
                  Any new enrollment (employee joining or dependent addition)
                  must be intimated and endorsed within 30 days.
                </li>
                <li>
                  Please maintain an adequate CD balance to ensure policy
                  coverage and seamless endorsements.
                </li>
                <li>
                  We recommend keeping an additional 10% amount in the CD
                  account to ensure coverage from inception.
                </li>
                <li>
                  The premium mentioned is indicative and subject to agreed
                  policy terms.
                </li>
                <li>
                  Coverage is subject to the agreed terms and conditions of the
                  policy.
                </li>
              </ol>
            </Box>
          </footer>
        </>
      )}
      {showDisplayBtn()}
    </div>
  );
}

export default PremiumCalc;

export const DownloadButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  gap: 2px;
  background-color: ${(props) => props.theme.accentColor};
  /* margin-top: 24px; */
  padding: 20px;
  cursor: pointer;
  max-width: 40%;
  height: 36px;
`;
